import { Menu } from 'antd';
import styled from 'styled-components';
import { SearchAutocompleteInput } from 'components/SearchAutocomplete/SearchAutocompleteInput';
import { commonSInput } from 'pages/EstimatePage/TableSection/TableSection.styled';
import { effect } from 'styles';

export const SearchContainer = styled.div`
  z-index: 100;
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 150px;
  position: relative;
`;

export const SearchMenu = styled(Menu)`
  background-color: ${({ theme }) => theme.color.white};
  border: 1px solid ${({ theme }) => theme.color.grey90};
  margin: 0 21px 0 21px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
`;

export const SItem = styled(Menu.Item)`
  padding: 12px 12px;
  ${effect.hover.colorBrand}
  ${effect.focus.colorBrand}
`;

export const SSearchInput = styled(SearchAutocompleteInput)<{ $isInvalid?: boolean }>`
  flex: 1;
  background-color: ${({ theme }) => theme.color.white};
  color: ${({ theme }) => theme.color.brand_black};
  ${commonSInput}
`;
